/* ==========================================================================
   Why Choose Eventfork — Square Corner Layout with Dotted Lines
   ========================================================================== */
import "../styles/Whychooseeventfork.css";

/* ---- inline icon set ---- */

const BellIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3.5c-2.6 0-4.6 2.1-4.6 4.7v2.9c0 .6-.2 1.2-.6 1.7l-1 1.3c-.6.8-.1 2 .9 2h11.6c1 0 1.5-1.2.9-2l-1-1.3c-.4-.5-.6-1.1-.6-1.7V8.2c0-2.6-2-4.7-4.6-4.7Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M10.2 19.2a1.9 1.9 0 0 0 3.6 0"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const TicketIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 9.5a2 2 0 0 0 0-4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.5a2 2 0 0 0 0 4v1a2 2 0 0 0 0 4v.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-.5a2 2 0 0 0 0-4v-1Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4.5v15"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeDasharray="1.6 2"
      strokeLinecap="round"
    />
  </svg>
);

const ShareIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="12" r="2.4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17.5" cy="6" r="2.4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17.5" cy="18" r="2.4" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M8.1 10.8 15.4 7M8.1 13.2l7.3 3.8"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3.6l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8 2.5-5.2Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

const HeartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 20s-7.3-4.4-9.6-9C.8 7.4 3 4 6.4 4c2 0 3.4 1.1 4.1 2.3.3.5 1.1.5 1.4 0C12.6 5.1 14 4 16 4c3.4 0 5.6 3.4 4 7-2.3 4.6-9.6 9-9.6 9Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="8.2" r="2.9" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M3.8 18.3c.6-2.9 2.7-4.5 5.2-4.5s4.6 1.6 5.2 4.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="16.3" cy="8.9" r="2.2" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M14.9 13.9c1.9.2 3.4 1.5 3.9 3.7"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

/* ---- content ---- */

const nodeData = [
  {
    id: "01",
    icon: <BellIcon />,
    title: "Personalized Alerts",
    description:
      "Get real-time notifications for events that match your interests and preferences.",
    position: "top-left",
  },
  {
    id: "02",
    icon: <TicketIcon />,
    title: "Easy Ticketing",
    description:
      "Secure, fast and hassle-free ticket booking for conferences,meetups and events of all sizes.",
    position: "top-right",
  },
  {
    id: "03",
    icon: <ShareIcon />,
    title: "Social Sharing",
    description:
      "Share events with your network and connect with fellow attendees before and after the event.",
    position: "bottom-right",
  },
  {
    id: "04",
    icon: <StarIcon />,
    title: "Event Reviews",
    description:
      "Read and write genuine reviews to help others discover the best events worth attending.",
    position: "bottom-left",
  },
];

const pointData = [
  {
    icon: <UsersIcon />,
    text: (
      <>
        Built for <strong>organizers</strong>.
      </>
    ),
  },
  {
    icon: <HeartIcon />,
    text: (
      <>
        Loved by <strong>attendees</strong>.
      </>
    ),
  },
  {
    icon: <StarIcon />,
    text: (
      <>
        Experience the future of events with <strong>powerful features</strong>{" "}
        and <strong>seamless experiences</strong>.
      </>
    ),
  },
];

const WhyChooseEventfork = () => {
  return (
    <section className="ef-why">
      <span className="ef-why__bg-dots ef-why__bg-dots--tl" aria-hidden="true" />
      <span className="ef-why__bg-dots ef-why__bg-dots--tr" aria-hidden="true" />
      <span className="ef-why__bg-dots ef-why__bg-dots--bl" aria-hidden="true" />

      <div className="ef-why__container">
        <div className="ef-why__grid">
          {/* Left copy column */}
          <div className="ef-why__intro">
            <span className="ef-why__eyebrow">
              Why Choose
              <i className="ef-why__eyebrow-rule" aria-hidden="true" />
            </span>

            <h2 className="ef-why__heading">
              Event<span className="ef-why__heading-accent">fork?</span>
            </h2>

            <i className="ef-why__divider" aria-hidden="true" />

            <p className="ef-why__lead">
              Everything you need to create, discover, and experience
              extraordinary conference,meetup,expo/exhibition,event.
            </p>

            <ul className="ef-why__points">
              {pointData.map((point, index) => (
                <li className="ef-why__point" key={index}>
                  <span className="ef-why__point-icon">{point.icon}</span>
                  <p className="ef-why__point-text">{point.text}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Square with dotted lines and features at corners */}
          <div className="ef-why__orbit">
            {/* Main square with dotted border */}
            <div className="ef-why__square">
              {/* Inner square */}
              <div className="ef-why__square-inner">
                <span className="ef-why__center-dot" />
              </div>
              
              {/* Corner connection lines */}
              <span className="ef-why__corner-line ef-why__corner-line--tl" />
              <span className="ef-why__corner-line ef-why__corner-line--tr" />
              <span className="ef-why__corner-line ef-why__corner-line--bl" />
              <span className="ef-why__corner-line ef-why__corner-line--br" />
            </div>

            {/* Feature nodes positioned at four corners */}
            {nodeData.map((node) => (
              <div
                className={`ef-why__node ef-why__node--${node.position}`}
                key={node.id}
              >
                <span className="ef-why__node-icon">
                  <i className="ef-why__node-dot" aria-hidden="true" />
                  {node.icon}
                </span>
                <div className="ef-why__node-copy">
                  <span className="ef-why__node-number">{node.id}</span>
                  <h4 className="ef-why__node-title">{node.title}</h4>
                  <i className="ef-why__node-rule" aria-hidden="true" />
                  <p className="ef-why__node-desc">{node.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseEventfork;